import axios from "axios"
import { API } from "../../../api/api"

export const getJobs = () => axios.get(API.url + "/jobs?populate=*").then((res) => res.data.data)
